import Vue from 'vue';
import { MutationTree } from 'vuex';

import baseWorkflowStore from '../../store/baseWorkflowStore';
import initialState from './initialState';
import { ApplicationMapsSeedingState, Calculation, WorkflowVariety } from './types';

const mutations: MutationTree<ApplicationMapsSeedingState> = {
  ...baseWorkflowStore.mutations,

  reset(state: ApplicationMapsSeedingState): void {
    const newState: ApplicationMapsSeedingState = initialState();
    Object.entries(newState).forEach(([key, value]) => {
      Vue.set(state, key, value);
    });
  },
  fetchVarieties(state: ApplicationMapsSeedingState): void {
    Vue.set(state.varieties, 'fetching', true);
  },
  setVarieties(state: ApplicationMapsSeedingState, varieties: WorkflowVariety[]): void {
    Vue.set(state.varieties, 'fetching', false);
    Vue.set(state.varieties, 'current', varieties);
  },
  setVarietiesFetching(state: ApplicationMapsSeedingState, fetching: boolean): void {
    Vue.set(state.varieties, 'fetching', fetching);
  },
  setCalculation(state: ApplicationMapsSeedingState, calculation: Calculation): void {
    Vue.set(state, 'calculation', calculation);
  },
  setCalculationField(state: ApplicationMapsSeedingState, data): void {
    Vue.set(state.calculation, data.key, data.value);
  },
  setQuantisationCode(state: ApplicationMapsSeedingState, quantisationCode: string): void {
    Vue.set(state, 'selectedQuantisationCode', quantisationCode);
  },
};

export default mutations;
